<template>
    <!-- 추천을 하면 취소 할수 없다 -->
    <div v-if="isRecommend">
        <base-button mode="disable" >
           <font-awesome-icon icon="check"/> <span v-if="isRecommend">추천</span><span v-else>추천</span>({{getCount}})
        </base-button>
    </div>
    <div v-else>
        <base-button mode="outline-red" @click="confirmRecommend()">
            추천({{getCount}})
        </base-button>
    </div>
    
</template>
<script>
export default {
    props:['count','postid','currentRecommend'],
    data(){
        return{
            recommend:false,            
        }
    },
    computed:{
        getCount(){            
            if(this.$store.state.posts.viewpost){
                return this.$store.state.posts.viewpost.recommend
            }else{
                return parseInt(this.count)
            }           
        },        
        isAuth() {
            return this.$store.getters.isAuthenticated;
        },
        isRecommend(){    
            console.log('추천 테스트', this.$store.state.posts.viewpost)
            if( this.$store.state.posts.viewpost && this.$store.state.posts.viewpost.recommends.length > 0)
            {
                return true;
            }else{
                return false;
            }              
        }
    },
    mount(){
        this.recommend = this.currentRecommend
    },
    methods: {
        confirmRecommend(){
            //로그인 체크
            if(!this.isAuth)
            {
                let result = confirm("로그인이 필요합니다.");
                if(result){
                    //this.$router
                    this.$router.push({ name: 'auth_login'});
                    return;
                }else{  
                    return;
                }
            }
            //본인이 쓴글인지 체크
            //let writer = this.$store.getters['posts/getposts'].data.find((post)=>post.id===this.postid).user_id;
            let writer = this.$store.state.posts.viewpost.user_id;
            let login_user = this.$store.getters.currentUser.id;
            if(writer ===login_user )
            {
                alert('본인이 작성한 글은 추천 하실수 없습니다.');
                return;
            }
            if(confirm('추천 하시겠습니까?'))
            {
                this.updateRecommend();
            }else{
                return;
            }
           
        },
        async updateRecommend(){
            
           
            try{
            let response='';
            const formData={
                //user_id:1,
                user_id:this.$store.getters.currentUser.id,
                post_id:this.postid
            }
            response = await this.$store.dispatch("posts/updateRecommend", formData)
            
            this.recommend = !this.recommend;
            if(response.isRecommend)
            {
                //this.$store.commit('updateUserPoint',response.point);
                this.$store.commit('updateUserPoint',response.user);   
                
                if(response.levelchange)
                {
                    alert('레벨이 변경되었습니다.');
                }
            }           
            
            this.$flashMessage.show({
                type: response.state,
                title: response.message,
                message: response.message,
                //
                });
            }catch(error)
            {
                console.log(error);
            }
            
            
        },
    },
}
</script>
